import { Controller } from "@hotwired/stimulus";

// Opens the message slide-over and drops a starter message into the composer as
// an editable draft. The composer lives inside the lazily-loaded
// message_center_chat_window turbo-frame, so we fill it as soon as it's present
// (immediately if already loaded, otherwise on turbo:frame-load).
export default class extends Controller {
  static targets = ["frame"];

  stage(event) {
    const text = event.currentTarget.dataset.messageDraftText || "";

    if (!this.fill(text)) {
      const frame = this.frameTarget;
      const handler = () => {
        this.fill(text);
        frame.removeEventListener("turbo:frame-load", handler);
      };
      frame.addEventListener("turbo:frame-load", handler);
    }
  }

  fill(text) {
    const textarea = this.frameTarget.querySelector('textarea[name="text"]');
    if (!textarea) return false;

    textarea.value = text;
    // Nudge the autogrow controller so the box resizes to fit the draft.
    textarea.dispatchEvent(new Event("input", { bubbles: true }));
    textarea.focus();
    textarea.setSelectionRange(textarea.value.length, textarea.value.length);
    return true;
  }
}
